module.exports = __webpack_public_path__ + "img/icon_dialog_qq.2f00a97b.png";